/**
 * OL Custom JavaScript
 * Mobile Menu Tabs Feature for MEN/WOMEN categories
 */

// Initialize features when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  initializeMobileMenuTabs();
  initializeInventoryDisplay();
  initializeCollectionSliderArrows();
  document.addEventListener('theme:resize:width', initializeCollectionSliderArrows);
  document.addEventListener('shopify:section:load', initializeCollectionSliderArrows);
});

/**
 * Main initialization function for mobile menu tabs
 */
function initializeMobileMenuTabs() {
  const mobileMenu = document.querySelector('[data-section-type="mobile-menu"]');
  if (!mobileMenu) return;

  // Find all menu blocks
  const menuBlocks = mobileMenu.querySelectorAll('.mobile-menu__block--menu');
  
  if (menuBlocks.length <= 1) return; // Need 2+ blocks to create tabs
  
  console.log('Found', menuBlocks.length, 'menu blocks, initializing tabs');
  
  // Create tabs wrapper and insert before first menu block
  const tabsWrapper = createTabNavigation(menuBlocks);
  const firstBlock = menuBlocks[0];
  firstBlock.parentNode.insertBefore(tabsWrapper, firstBlock);
  
  // Wrap menu blocks in tab containers
  menuBlocks.forEach((block, index) => {
    const tabContent = document.createElement('div');
    tabContent.className = 'mobile-menu__tab-content';
    tabContent.setAttribute('data-tab', index);
    if (index === 0) tabContent.classList.add('current');
    
    block.parentNode.insertBefore(tabContent, block);
    tabContent.appendChild(block);
  });
  
  // Add click and keyboard handlers
  attachTabHandlers(mobileMenu);
}



/**
 * Create the tab navigation HTML structure
 * @param {NodeList} blocks - Menu blocks to create tabs for
 * @returns {HTMLElement} - Tab wrapper element
 */
function createTabNavigation(blocks) {
  const wrapper = document.createElement('div');
  wrapper.className = 'mobile-menu__tabs-wrapper block-padding';
  
  const nav = document.createElement('div');
  nav.className = 'tabs__head';
  
  const list = document.createElement('ul');
  list.className = 'tabs';
  list.setAttribute('data-mobile-menu-tabs', '');
  
  blocks.forEach((block, index) => {
    const li = document.createElement('li');
    li.className = 'tab-link' + (index === 0 ? ' current' : '');
    li.setAttribute('data-tab', index);
    li.setAttribute('tabindex', '0');
    li.setAttribute('role', 'tab');
    li.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
    
    // Simple index-based labeling to ensure correct labels
    const tabLabels = ['MEN', 'WOMEN', 'TAB 3', 'TAB 4'];
    const menuLabel = tabLabels[index] || `TAB ${index + 1}`;
    
    li.textContent = menuLabel;
    
    list.appendChild(li);
  });
  
  nav.appendChild(list);
  wrapper.appendChild(nav);
  return wrapper;
}

/**
 * Attach event handlers for tab switching
 * @param {HTMLElement} mobileMenu - Mobile menu container
 */
function attachTabHandlers(mobileMenu) {
  const tabLinks = mobileMenu.querySelectorAll('[data-mobile-menu-tabs] .tab-link');
  const tabContents = mobileMenu.querySelectorAll('.mobile-menu__tab-content');
  
  tabLinks.forEach((link, index) => {
    // Click handler
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const tabIndex = this.getAttribute('data-tab');
      switchToTab(tabIndex, tabLinks, tabContents);
    });
    
    // Keyboard navigation
    link.addEventListener('keydown', function(e) {
      let newIndex = index;
      
      switch(e.key) {
        case 'ArrowRight':
          e.preventDefault();
          newIndex = (index + 1) % tabLinks.length;
          break;
        case 'ArrowLeft':
          e.preventDefault();
          newIndex = (index - 1 + tabLinks.length) % tabLinks.length;
          break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          const tabIndex = this.getAttribute('data-tab');
          switchToTab(tabIndex, tabLinks, tabContents);
          return;
        default:
          return;
      }
      
      // Focus on new tab
      tabLinks[newIndex].focus();
      const newTabIndex = tabLinks[newIndex].getAttribute('data-tab');
      switchToTab(newTabIndex, tabLinks, tabContents);
    });
  });
}

/**
 * Switch to a specific tab
 * @param {string} tabIndex - Index of tab to switch to
 * @param {NodeList} tabLinks - Tab button elements
 * @param {NodeList} tabContents - Tab content elements
 */
function switchToTab(tabIndex, tabLinks, tabContents) {
  // Update tab buttons
  tabLinks.forEach(link => {
    link.classList.remove('current');
    link.setAttribute('aria-selected', 'false');
  });
  
  const activeTab = document.querySelector(`[data-mobile-menu-tabs] [data-tab="${tabIndex}"]`);
  if (activeTab) {
    activeTab.classList.add('current');
    activeTab.setAttribute('aria-selected', 'true');
  }
  
  // Update content
  tabContents.forEach(content => content.classList.remove('current'));
  const activeContent = document.querySelector(`.mobile-menu__tab-content[data-tab="${tabIndex}"]`);
  if (activeContent) {
    activeContent.classList.add('current');
  }
}

/**
 * Extract menu label from block or return default based on index
 * @param {HTMLElement} block - Menu block element
 * @param {number} index - Block index
 * @returns {string} - Menu label
 */
function getMobileMenuLabel(block, index) {
  // Try to extract from menu handle if data attribute exists
  const linkList = block.querySelector('[data-links]');
  if (linkList) {
    // Check if menu handle contains 'men' or 'women'
    const dataAttrs = block.outerHTML.toLowerCase();
    if (dataAttrs.includes('main-menu-for-men') || dataAttrs.includes('men')) return 'MEN';
    if (dataAttrs.includes('main-menu-for-women') || dataAttrs.includes('women')) return 'WOMEN';
  }
  
  // Default labels based on index
  const defaultLabels = ['MEN', 'WOMEN', 'TAB 3', 'TAB 4'];
  return defaultLabels[index] || `TAB ${index + 1}`;
}

/**
 * Initialize size-based inventory display functionality
 */
function initializeInventoryDisplay() {
  const variantSelects = document.querySelector('variant-selects');
  
  if (!variantSelects) {
    return;
  }
  
  // Initial load - update inventory display for current variant immediately
  const initialVariantScript = document.querySelector('[data-selected-variant]');
  
  if (initialVariantScript) {
    try {
      const initialVariant = JSON.parse(initialVariantScript.textContent);
      
      // Update immediately on page load
      setTimeout(() => {
        updateInventoryDisplay(initialVariant);
      }, 100);
      
    } catch (error) {
      console.warn('Could not parse initial variant data:', error);
    }
  }
  
  // Listen for variant selection changes
  variantSelects.addEventListener('optionValueSelectionChange', function(e) {
    // Show loading state immediately when variant changes
    setInventoryLoadingState(true);
    
    // Update inventory display with new variant
    updateInventoryDisplay(e.detail.selectedVariant);
  });
  
  // Listen for any variant change events
  variantSelects.addEventListener('variantChange', function(e) {
    // Additional debugging if needed
  });
  
  // FALLBACK: Monitor radio button clicks directly
  
  // Try different selectors to find the actual radio buttons
  const selectors = [
    'input[type="radio"][name*="option"]',
    'input[type="radio"]',
    'input[name*="Size"]',
    'input[name*="options"]',
    '.radio__buttons input',
    'variant-selects input',
    'fieldset input[type="radio"]'
  ];
  
  let radioButtons = [];
  selectors.forEach(selector => {
    const found = document.querySelectorAll(selector);
    if (found.length > 0 && radioButtons.length === 0) {
      radioButtons = found;
    }
  });
  
  if (radioButtons.length === 0) {
    // No radio buttons found for fallback
    return;
  }
  
  radioButtons.forEach((radio, index) => {
    radio.addEventListener('change', function(e) {
      // Wait a bit for variant-selects to update, then get current variant
      setTimeout(() => {
        const currentVariant = variantSelects.currentVariant;
        updateInventoryDisplay(currentVariant);
      }, 200);
    });
  });
}

/**
 * Update inventory display based on selected variant
 * @param {Object} variant - Selected variant object
 */
function updateInventoryDisplay(variant) {
  const inventoryDisplay = document.querySelector('.ol-custom-inventory-display');
  if (!inventoryDisplay) {
    return;
  }
  
  // Check if variant has inventory management
  if (!variant) {
    return;
  }
  
  if (!variant.inventory_management) {
    return;
  }
  
  // If inventory_policy is 'continue', don't show inventory count
  if (variant.inventory_policy === 'continue') {
    return;
  }
  
  const inventory = variant.inventory_quantity;
  
  // Handle undefined inventory quantity
  if (inventory === undefined || inventory === null) {
    if (variant.available === false) {
      const status = 'out-of-stock';
      const statusText = '在庫なし';
      showInventoryDisplay(inventoryDisplay, status, statusText);
      return;
    } else {
      const status = 'in-stock';
      const statusText = '在庫あり';
      showInventoryDisplay(inventoryDisplay, status, statusText);
      return;
    }
  }
  
  // Determine inventory status
  let status = '';
  let statusText = '';
  
  if (inventory >= 3) {
    status = 'in-stock';
    statusText = '在庫あり';
  } else if (inventory === 2) {
    status = 'low-stock';
    statusText = '残りわずか';
  } else if (inventory === 1) {
    status = 'very-low-stock';
    statusText = '残り1点';
  } else if (inventory <= 0) {
    status = 'out-of-stock';
    statusText = '在庫なし';
  }
  
  if (status) {
    showInventoryDisplay(inventoryDisplay, status, statusText);
  }
}





/**
 * Show inventory display with specified status
 * @param {HTMLElement} display - Inventory display element
 * @param {string} status - Status class (in-stock, low-stock, etc.)
 * @param {string} text - Status text to display
 */
function showInventoryDisplay(display, status, text) {
  // Add updating class for animation
  display.classList.add('ol-custom-inventory-display--updating');
  
  // Find or create status element
  let statusElement = display.querySelector('.ol-custom-inventory-display__status');
  if (!statusElement) {
    statusElement = document.createElement('span');
    statusElement.className = 'ol-custom-inventory-display__status';
    
    // Get icon element (should already exist from Liquid rendering)
    const iconElement = display.querySelector('.icon') || createInventoryIcon(status);
    const textElement = document.createElement('span');
    textElement.className = 'ol-custom-inventory-display__text';
    
    statusElement.appendChild(iconElement);
    statusElement.appendChild(textElement);
    display.appendChild(statusElement);
  }
  
  // Update status class
  statusElement.className = `ol-custom-inventory-display__status ol-custom-inventory-display__status--${status}`;
  
  // Update text content
  const textElement = statusElement.querySelector('.ol-custom-inventory-display__text');
  if (textElement) {
    textElement.textContent = text;
  }
  
  // Show display
  display.style.display = 'block';
  display.setAttribute('data-inventory-display', '');
  
  // Remove animation class after animation completes
  setTimeout(() => {
    display.classList.remove('ol-custom-inventory-display--updating');
  }, 300);
}

/**
 * Hide inventory display
 * @param {HTMLElement} display - Inventory display element
 */
function hideInventoryDisplay(display) {
  display.style.display = 'none';
  display.removeAttribute('data-inventory-display');
}

/**
 * Create inventory icon element based on status
 * @param {string} status - Status type for appropriate icon
 * @returns {HTMLElement} - Icon element
 */
function createInventoryIcon(status) {
  const icon = document.createElement('span');
  icon.className = 'icon';
  
  // Simple fallback icon (you can enhance this with actual SVGs)
  let iconContent = '';
  switch(status) {
    case 'in-stock':
      iconContent = '✓';
      break;
    case 'low-stock':
    case 'very-low-stock':
      iconContent = '!';
      break;
    case 'out-of-stock':
      iconContent = '×';
      break;
    default:
      iconContent = '?';
  }
  
  icon.textContent = iconContent;
  return icon;
}

function initializeCollectionSliderArrows() {
  var isMobileTouch = Boolean(window.theme && window.theme.isMobile && window.theme.touch);

  document.querySelectorAll('.ol-custom-section-collection').forEach(function(section) {
    var gridSlider = section.querySelector('grid-slider');
    if (!gridSlider) return;

    var slider = gridSlider.querySelector('[data-grid-slider]');
    if (!slider || !slider.classList.contains('grid--mobile-slider')) {
      removeGeneratedCollectionArrows(section);
      return;
    }

    if (!isMobileTouch) {
      removeGeneratedCollectionArrows(section);
      return;
    }

    var arrowsDiv = section.querySelector('[data-ol-custom-generated-arrows]');
    if (!arrowsDiv) {
      arrowsDiv = document.createElement('div');
      arrowsDiv.className = 'slider__arrows';
      arrowsDiv.setAttribute('data-ol-custom-generated-arrows', '');
      arrowsDiv.innerHTML = [
        '<button type="button" class="slider__button slider__button--prev" aria-label="前へ">前へ</button>',
        '<button type="button" class="slider__button slider__button--next" aria-label="次へ">次へ</button>'
      ].join('');

      gridSlider.insertAdjacentElement('afterend', arrowsDiv);
    }

    bindCollectionArrowEvents(gridSlider, slider, arrowsDiv);
  });
}

function removeGeneratedCollectionArrows(section) {
  section.querySelector('[data-ol-custom-generated-arrows]')?.remove();
}

function bindCollectionArrowEvents(gridSlider, slider, arrowsDiv) {
  if (arrowsDiv.dataset.olCustomBound === 'true') {
    arrowsDiv._olCustomUpdateState?.();
    return;
  }

  var prevBtn = arrowsDiv.querySelector('.slider__button--prev');
  var nextBtn = arrowsDiv.querySelector('.slider__button--next');
  if (!prevBtn || !nextBtn) return;

  function getSlides() {
    return Array.prototype.slice.call(slider.querySelectorAll('[data-grid-item]'));
  }

  function getCurrentIndex(slides) {
    var currentIndex = 0;
    var minDistance = Number.POSITIVE_INFINITY;
    var currentScroll = slider.scrollLeft;

    slides.forEach(function(slide, index) {
      var distance = Math.abs(slide.offsetLeft - currentScroll);
      if (distance < minDistance) {
        minDistance = distance;
        currentIndex = index;
      }
    });

    return currentIndex;
  }

  function updateDisabledState() {
    var slides = getSlides();
    if (!slides.length) {
      prevBtn.disabled = true;
      nextBtn.disabled = true;
      return;
    }

    var currentIndex = getCurrentIndex(slides);
    prevBtn.disabled = currentIndex <= 0;
    nextBtn.disabled = currentIndex >= slides.length - 1;
  }

  function goToRelativeSlide(step) {
    var slides = getSlides();
    if (!slides.length) return;

    var currentIndex = getCurrentIndex(slides);
    var nextIndex = Math.max(0, Math.min(slides.length - 1, currentIndex + step));
    var targetSlide = slides[nextIndex];
    if (!targetSlide) return;

    if (typeof gridSlider.goToSlide === 'function') {
      gridSlider.goToSlide(targetSlide);
    } else {
      slider.scrollTo({ top: 0, left: targetSlide.offsetLeft, behavior: 'smooth' });
    }
  }

  prevBtn.addEventListener('click', function(e) {
    e.preventDefault();
    goToRelativeSlide(-1);
  });

  nextBtn.addEventListener('click', function(e) {
    e.preventDefault();
    goToRelativeSlide(1);
  });

  slider.addEventListener('scroll', updateDisabledState, { passive: true });

  arrowsDiv.dataset.olCustomBound = 'true';
  arrowsDiv._olCustomUpdateState = updateDisabledState;
  updateDisabledState();
}

//BLOG
const BlogTagFilter = document.getElementById('BlogTagFilter');
if (BlogTagFilter != null) {
	BlogTagFilter.addEventListener('change', function (e) {
		location.href = location.origin + '/' + e.target.value;
	}, false);
}